import * as React from 'react';

const ArrowIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg width="16" height="9" viewBox="0 0 16 9" {...props}>
    <path d="M15.84.928a.48.48 0 0 1 .16.356.48.48 0 0 1-.16.355L8.369 8.845a.516.516 0 0 1-.738 0L.161 1.64A.48.48 0 0 1 0 1.284.48.48 0 0 1 .16.928L.962.155a.516.516 0 0 1 .737 0L8 6.232 14.3.155a.516.516 0 0 1 .738 0l.802.773z" />
  </svg>
);

export { ArrowIcon };
